module.exports = __webpack_public_path__ + "static/media/cemetery.dbaab1b2.jpg";